/** Title bar label of every window the desktop can open. */
export enum Windows {
    CV = 'CV',
    SelfDocument = 'SelfDocument.tsx',
    Minesweeper = 'Minesweeper',
    PieChart = 'Pie Chart',
}
